"use strict";

exports.__esModule = true;
exports.formatUnitValue = exports.UnitValue = void 0;
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
var _react = _interopRequireDefault(require("react"));
var _Catalogs = require("../../../Catalogs");
var _DurationValue = require("./DurationValue");
var _PointValue = require("./PointValue");
var _approximateFontSize = require("../approximateFontSize");
var _unitDefinitions = require("../../../Catalogs/Units/unitDefinitions");
var _calculateXY2 = require("../calculateXY");
var _constants = require("../../constants");
var _excluded = ["width", "height", "units", "value", "fontSize", "textAnchor", "hideMtcAgentUnits"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * The text a value is drawn as in its units: "-" for nothing, a fraction as a
 * whole percentage, other numbers rounded to what the unit warrants. Shared
 * with the tiles that size themselves by this text before it is drawn.
 */
var formatUnitValue = exports.formatUnitValue = function formatUnitValue(value, unitDefinition) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  if (unitDefinition.type === "number") {
    var numericValue = Number(value) || 0;
    if (unitDefinition.name === _unitDefinitions.UNIT_FRACTIONAL_PERCENT) {
      return Math.round(numericValue * 100).toString();
    }
    var rounded = Math.round(numericValue);
    if (unitDefinition.name === _unitDefinitions.UNIT_PERCENT || rounded === value) {
      return rounded.toString();
    }
    if (numericValue < 1) {
      return (Math.round(value * 1000) / 1000).toString();
    }
    return (Math.round(value * 100) / 100).toString();
  }
  return String(value);
};

/**
 * Displays a value in units.
 */
var UnitValue = exports.UnitValue = function UnitValue(props) {
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var width = props.width,
    height = props.height,
    units = props.units,
    value = props.value,
    fontSize = props.fontSize,
    _props$textAnchor = props.textAnchor,
    textAnchor = _props$textAnchor === void 0 ? _constants.TEXT_ANCHOR_MIDDLE : _props$textAnchor,
    hideMtcAgentUnits = props.hideMtcAgentUnits,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  if (units === _unitDefinitions.UNIT_MILLISECOND || units === _unitDefinitions.UNIT_SECOND) {
    var validatedValue = Number(value) || 0;
    var valueForUnit = units === _unitDefinitions.UNIT_MILLISECOND ? validatedValue : validatedValue * 1000;
    return /*#__PURE__*/_react["default"].createElement(_DurationValue.DurationValue, _extends({
      width: width,
      height: height,
      value: valueForUnit,
      fontSize: fontSize,
      textAnchor: textAnchor
    }, extra));
  } else if (units === _unitDefinitions.UNIT_MILLIMETER_3D) {
    return /*#__PURE__*/_react["default"].createElement(_PointValue.PointValue, _extends({
      width: width,
      height: height,
      value: String(value)
    }, extra));
  }
  var unitDefinition = (0, _Catalogs.getUnitDefinition)(units);
  var formattedValue = formatUnitValue(value, unitDefinition);
  var autoFontSize = (0, _approximateFontSize.approximateFontSize)({
    width: width,
    height: height,
    value: "" + formattedValue + unitDefinition.symbol.slice(Math.floor(unitDefinition.symbol.length / 2))
  });
  // Modern: the configured size is a cap; legacy: it is the size.
  var valueFontSize = modern ? (0, _approximateFontSize.fitFontSize)(fontSize, autoFontSize) : fontSize || autoFontSize;
  var _calculateXY = (0, _calculateXY2.calculateXY)({
      width: width,
      height: height,
      textAnchor: textAnchor
    }),
    x = _calculateXY.x,
    y = _calculateXY.y;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height
  }, extra, {
    "data-testid": "UnitValue"
  }), /*#__PURE__*/_react["default"].createElement("text", {
    x: x,
    y: y,
    textAnchor: textAnchor,
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: valueFontSize,
    fontWeight: "bold",
    alignmentBaseline: "middle",
    "data-testid": "UnitValueSpan"
  }, formattedValue), " ", hideMtcAgentUnits ? null : /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: valueFontSize * 0.5,
    alignmentBaseline: "middle",
    "data-testid": "UnitSymbolSpan"
  }, unitDefinition.symbol)));
};